import React, { useState } from 'react'
import Modal from 'components/atoms/Modal'
import { useDispatch } from 'react-redux'
import Button from 'components/atoms/Button'
import RemoveIcon from 'components/icons/RemoveIcon'
import { removePackingTypeRoutine } from 'modules/packingTypes/ducks/actions'
import ButtonWrapper from 'theme/wrappers'

const RemovePackingTypeModal = ({ type }) => {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleModalOpen = e => {
    e.stopPropagation()
    setOpen(true)
  }
  const handleModalClose = e => {
    e && e.stopPropagation()
    setOpen(false)
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(removePackingTypeRoutine({
      id: type.id,
      callback: handleModalClose
    }))
  }

  return (
    <>
      <RemoveIcon onClick={handleModalOpen} />
      <Modal
        open={open}
        title='Usunięcie opakowania'
        onClose={handleModalClose}
      >
        Czy na pewno chcesz usunąć opakowanie &quot;{type.name}&quot;
        <ButtonWrapper>
          <Button
            onClick={handleModalClose}
            color='primary-outline'
          >
            Anuluj
          </Button>
          <Button
            onClick={handleSubmit}
            color='primary'
          >
            Usuń
          </Button>
        </ButtonWrapper>
      </Modal>
    </>
  )
}

export default RemovePackingTypeModal
